export default __webpack_public_path__ + "static/media/BehaviorBreakdownMobile.e9473271.png";